<template>
    <v-footer v-if="!$route.meta.hideNavigation" app color="oug" dark elevation="24">
      <v-row class="copy" no-gutters>
        <v-col cols="12" align="center">
          &copy; {{ new Date().getFullYear() }} —
          <strong>{{ Title }}</strong>
        </v-col>
      </v-row>
    </v-footer>
</template>

<script>
export default {
    name: 'Header',
    components: {
    },
  props: {
    Title: {
      Type: String,
      Required: true
    }
  },
  data() {
    return {
    }
  },
  methods: {},
  computed: {},
}
        
</script>

<style lang="scss" scoped>

</style>